<template>
  <div class="Others14Charts" :class="getStyle('title')">
    <div class="result">
      <div
        class="videoList"
        v-for="(item, index) in videoList"
        :key="index"
        :class="{ active: index === currentIndex }"
      >
        <div class="video" @mousedown="handleShowMonitor($event, item, index)">
          <img v-if="ProjectInfo.Style.componentName === 'V11Style'" src="@/assets/img/triangle_img1.png" />
          <img v-else src="@/assets/img/triangle_img.png" alt="" />
          <span>{{ item.title }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '../../../assets/icon/patrol.png';
import { request } from '../../../common/request';
export default {
  name: 'Others8Charts',
  components: {},
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      echartsOptions: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      videoList: [], // 点
      currentIndex: 0,
      SwitchValue: '',
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function (val) {
        this.SwitchValue = val.propertyData.mapPopupData.value.mapComponentName;
        if (this.Configuration.isScaling) {
          console.log('scale');
        } else if (this.Configuration.isMoving) {
          console.log('mov');
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    this.getStyle();
    this.getApiDataResByFilterAndResponseQuery();
    this.SwitchValue = this.Configuration.propertyData.mapPopupData.value.mapComponentName;
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.unRegisterDebounceAndThrottle();
    console.log('卸载！！！！！！');
  },
  computed: {
    style() {
      return this.ProjectInfo.Style.componentName;
    },
  },
  methods: {
    getStyle(e = '') {
      let style = {};
      let bool = e == 'title';
      switch (this.style) {
        case 'V1Style':
          style = {};
          if (bool) style['V1StyleTitle'] = true;
          style['V1Style'] = true;
          break;
        case 'V2Style':
          style = {};
          if (bool) style['V2StyleTitle'] = true;
          style['V2Style'] = true;
          break;
        case 'V3Style':
          style = {};
          if (bool) style['V3StyleTitle'] = true;
          style['V3Style'] = true;
          break;
        case 'V4Style':
          style = {};
          if (bool) style['V4StyleTitle'] = true;
          style['V4Style'] = true;
          break;
        case 'V5Style':
          style = {};
          if (bool) style['V5StyleTitle'] = true;
          style['V5Style'] = true;
          break;
        case 'V6Style':
          style = {};
          if (bool) style['V6StyleTitle'] = true;
          style['V6Style'] = true;
          break;
        case 'V7Style':
          style = {};
          if (bool) style['V7StyleTitle'] = true;
          style['V7Style'] = true;
          break;
        case 'V8Style':
          style = {};
          if (bool) style['V8StyleTitle'] = true;
          style['V8Style'] = true;
          break;
        case 'V9Style':
          style = {};
          if (bool) style['V9StyleTitle'] = true;
          style['V9Style'] = true;
          break;
        case 'V11Style':
          style = {};
          if (bool) style['V11StyleTitle'] = true;
          style['V11Style'] = true;
          break;
        default:
          break;
      }
      return style;
    },
    handleShowMonitor(e, video, index) {
      e.stopPropagation();
      console.log(e, index, 'e 点位！');
      this.currentIndex = index;
      this.$store.commit('setCurrentMonitor', index);
    },
    getShowfontSizeBase() {
      return Math.round(this.Configuration.style.height / 20);
    },
    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      // clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      clearInterval(this.staticIntervalTaskID2);
      // this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      let grid = {};
      let chartColor = [];
      let source = [];
      let seriesList = [];
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };
      if (this.Configuration.propertyData?.chartsColor?.value?.chartColor) {
        chartColor = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      if (ParamData) {
        source = ParamData;
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
      }
      console.log(source, 'source 14 数据');
      console.log(seriesList);
      console.log(chartColor);
      console.log(fontStyle);
      console.log(grid);

      let video = [];

      function DealData() {
        source.forEach(item => {
          video.push({
            title: item.name,
            longitude: item.longitude,
            latitude: item.latitude,
            content: item.content,
            // icon: 'http://emerc.xyabcd.com/icon/patrol.png', // 覆盖物图标
            icon: item.type ? item.type : Icon, // 覆盖物图标
            // icon: 'https://minio.xyabcd.com/datamanage/wws/images/20250107/20250107140841-m3.png', // 覆盖物图标
            infowindowshowLink: '1',
            outcode: item.outcode ? item.outcode : '',
            infowindowiframeUrl: item.outsrc, // 视频流
            infowindowData: item.infowindowData ? item.infowindowData : {}, // 弹窗数据
            healthStatus: item.healthStatus ? item.healthStatus : '', // 状态
          });
        });
      }

      DealData();
      console.log(video, 'video video');
      this.videoList = video;
      let VideoData = {
        Video: this.videoList,
        SwitchValue: this.SwitchValue,
      };
      console.log(VideoData, 'VideoData');
      this.$store.commit('setPointList', VideoData);
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          let data = this.$_.cloneDeep(ChartsData.staticData);

          this.setEchartsOptions(data.source);
        };
        clearInterval(this.staticIntervalTaskID);
        func();

        this.staticIntervalTaskID = setInterval(() => {
          console.log('任务执行staticData');
          console.log(chartsAnimation);
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);

        this.staticIntervalTaskID2 = setInterval(() => {
          func();
        }, (chartsAnimation?.staticRefreshIntervalTime - 2 <= 0 ? 1 : chartsAnimation?.staticRefreshIntervalTime - 2) * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
        };
        func();
        this.apiIntervalTaskID = setInterval(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }

        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          let params = ChartsData.apiData.apiPostParams || '{}';
          // this.axios({
          //   method: ChartsData.apiData.apiUrlMethod,
          //   url: ChartsData.apiData.apiUrl,
          //   params: eval('(' + params + ')'),
          //   headers: header,
          // })
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: eval('(' + params + ')'),
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          let params = ChartsData.apiData.apiPostParams || '{}';
          // this.axios({
          //   method: ChartsData.apiData.apiUrlMethod,
          //   url: ChartsData.apiData.apiUrl,
          //   data: eval('(' + params + ')'),
          //   headers: header,
          // })
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function (data, filter_text) {
          let dataSet = {};
          eval(filter_text);
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            // console.log('getApiDataResByFilterAndResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  },

  Configuration: {
    componentTitle: '地图组件',
    componentName: 'Others14Charts',
    componentOverViewImg: './img/charts/OthersCharts/Others14Charts.png',
    id: '',
    style: {
      width: 250,
      height: 280,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },

      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts0Border',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://m.cqlpmysblzh.com/gthmmc/index.php?m=amobiletour&c=dataMange&a=queryDataOfResource&pageNo=1&pageNum=999&directory_code=video',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.data',
            isUseFilter: false,
            apiFilter: ``,
            apiUrlMethod: 'get',
            isUseInterval: false,
            apiInterval: 10,
          },
          staticData: {
            seriesList: [],
            source: [
              {
                name: '地址一',
                outsrc: '',
                latitude: 0,
                longitude: 0,
              },
              {
                name: '地址一',
                outsrc: '',
                latitude: 0,
                longitude: 0,
              },
              {
                name: '地址一',
                outsrc: '',
                latitude: 0,
                longitude: 0,
              },
              {
                name: '地址一',
                outsrc: '',
                latitude: 0,
                longitude: 0,
              },
            ],
          },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 80,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      mapPopupData: {
        propertyComponentName: 'MapPopup',
        value: {
          mapComponentName: 'point',
        },
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Others14Charts {
  background-color: #1c232e9e;
  border-radius: 10px;
  width: 100%;
  height: 100%;
  padding: 20px 10px;
  position: relative;

  .title {
    font-size: 16px;
    font-weight: bold;
    color: #4ed6f6;

    span {
      line-height: 2;
      font-size: 14px;
      position: relative;
      left: 28px;
      top: 4px;
    }
  }

  .result {
    height: 98%;
    overflow-y: auto;
    padding: 10px;
    border-radius: 10px;

    .videoList {
      padding: 6px 0 6px 12px;

      // min-height: 30px;
      .video {
        &:hover {
          cursor: pointer;
        }

        display: flex;
        align-items: center;

        span {
          &:nth-child(2) {
            color: #000;
            font-size: 14px;
          }
        }
      }
    }
    &::-webkit-scrollbar-thumb {
      background: #ff000052 !important;
      width: 4px !important;
      height: 3px !important;
    }
    &::-webkit-scrollbar {
      width: 4px !important;
      height: 3px !important;
    }
    &::-webkit-scrollbar-track {
      background: #43455800;
    }
  }
}
.Others14Charts.V11Style {
  background-color: #330a09;
  .videoList {
    background-color: #1f0303;
    margin-bottom: 6px;
  }
  .videoList .video span {
    color: #fff !important;
    margin-left: 8px !important;
  }
  .active {
    background: url('../../../assets/img/gis-active.png') no-repeat;
    background-color: #00000000;
    background-size: 100% 100%;
  }
}
:deep(.el-input__inner) {
  background: none;
  border: 1px solid #357494;
  color: #fff;
}

.active {
  background: #1bc4c9;
  color: #fff !important;
}

@import '../../../scss/mapbackstyle.scss';
</style>
